<div class="row">
    <div class="form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 datepicker-custom ">
        <div class="form-inline">
            <div class="form-group input-datepicker">
                <input   [minDate]="{year: 2021, month: 1, day: 1}"  (ngModelChange)="globalData.aggiornaDatiRiepilogoIncassi(globalData.datePicker.dataSelezionata)" autocomplete="off" class="form-control btn-datepicker-selector btn-info " (click)="datePickerId.toggle()" placeholder="gg-mm-aaaa"
                    name="dp" [(ngModel)]="globalData.datePicker.dataSelezionata" ngbDatepicker #datePickerId="ngbDatepicker"> 

                <a (click)="globalData.aggiornaDatiRiepilogoIncassi(globalData.datePicker.dataSelezionata)"
                    skipLocationChange=true class="btn btn-primary btn-datepicker">Scegli
                    una data</a>
            </div>
        </div> 
    </div>
</div>